// Product collection page folding information
$(document).ready(function () {
  $('.accordion').accordion({
    defaultOpen: 'section1',
    cookieName: 'accordion_nav'
  });
  $(".tt-btn-toggle").click(function(){
    $(".wd-product-collection-filter-mobile-close-icon").show();
  });
  $("body").click(function(){
    if(!$(".leftColumn.aside").hasClass("column-open")){
      $(".wd-product-collection-filter-mobile-close-icon").hide();
    }
  });
  
});